import { render, staticRenderFns } from "./tagAddUpdate.vue?vue&type=template&id=66188de3"
import script from "./tagAddUpdate.vue?vue&type=script&lang=js"
export * from "./tagAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports